import { ReportDetailsQuery } from '@/__generated__/graphql';
import { abyssColors } from '@/theme/colors';
import { Box, TextField } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';

export const PaintBlockReportRemarksField = ({
  isEditMode = false,
  editSelectedReport,
  setEditSelectedReport,
}: {
  isEditMode?: boolean;
  editSelectedReport: ReportDetailsQuery['report'] | undefined;
  setEditSelectedReport: Dispatch<SetStateAction<ReportDetailsQuery['report'] | undefined>>;
}) => {
  return (
    <Box
      sx={{
        background: abyssColors.primary[50],
        border: `1px solid ${abyssColors.primary[100]}`,
        margin: '0 16px',
        '& .MuiInputBase-input.Mui-disabled': {
          color: abyssColors.primary[400],
          WebkitTextFillColor: abyssColors.primary[400],
          opacity: 1,
        },
      }}
    >
      <TextField
        data-testid="remarks-field"
        placeholder={isEditMode ? 'Enter remarks here' : 'No remarks available.'}
        value={editSelectedReport?.templateFieldData?.remarks ?? ''}
        multiline
        fullWidth
        variant="outlined"
        rows={4}
        onChange={(event) => {
          const value = event.target.value;
          setEditSelectedReport((previousState) => {
            if (!editSelectedReport) return previousState;
            return {
              ...editSelectedReport,
              templateFieldData: {
                ...editSelectedReport.templateFieldData,
                remarks: value,
              },
            };
          });
        }}
        disabled={!isEditMode}
      />
    </Box>
  );
};
